import { OwnershipTransferStatus } from 'src/common/enums';

// Interfaces used in the View Client.
export interface ResourcePermalink {
    id: number;
    permalink: string;
}

export enum PermalinkType {
    SHEET = 'SHEET',
    REPORT = 'REPORT',
    WORKSPACE = 'WORKSPACE',
    FOLDER = 'FOLDER',
    DASHBOARD = 'DASHBOARD',
    CONTAINER = 'CONTAINER',
}

export interface PermalinkRequestItem {
    type: PermalinkType;
    id: number;
}

// Interfaces used in the Workspace Client.
export interface SearchResults {
    searchResults: SearchItem[];
    maskedWorkspaces: WorkspacesMap[];
}

export interface SearchItem {
    maskedContainerId: number;
    maskedDisplayObjectId: number;
    apiResultType: string;
    highLightSearchText: string;
    maskedParentContainerInfo: ParentItem;
}

export interface ParentItem {
    containerType: string;
    name: string;
    maskedWorkspaceId: number;
    maskedContainerId: number;
    maskedDisplayObjectId: number;
}

export interface WorkspacesMap {
    maskedWorkspaceId: number;
    name: string;
    personalWorkspace: boolean;
}

// Interfaces used in the Ownership Transfer Client.
export interface TransferOwnershipRequest {
    viewId: string;
    email: string;
}
export interface TransferOwnershipStatus {
    status: OwnershipTransferStatus;
}
